import { Col, Row } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';
import {Link} from "react-router-dom";
import { clientConfig } from '../../../utilities/configService';

export const ElectricVehicleTypes = () => {
    return (
        <div id="electric-vehicle-types">
            <ContentBlock className="evFundamentalsSection">
                <ContentHeading title="Electric Vehicle Types" />
                <ContentBody>
                    <div className="heading5">EVs come in all different shapes and sizes that meet a variety of needs from daily drivers to commercial vehicles and larger transport vehicles. To keep it simple, we can classify them all as light-, medium-, or heavy-duty EVs.</div>
                    <Row className="tableBlock">
                        <Col>
                            {/* EV types table - Light duty EV */}
                            <Row className="mb-3 electricVehicleTypesTable surface6Border">
                                <Col sm={12} md={12} lg={2} className="electricVehicleTypesTableLeft surface6Background" >
                                    <div className="content">
                                        Light-Duty EVs
                                    </div>
                                </Col>
                                <Col sm={12} md={6} lg={4} className="electricVehicleTypesTableCenter" >
                                    <div className="content">
                                        <div className="header">
                                            Up to 10,000 pounds
                                        </div>
                                        <p>
                                            Vehicles with a gross vehicle weight rating (GVWR) less than or equal to 10,000 pounds (i.e., Class 1 and Class 2 vehicles, as designated by the U.S. Department of Transportation (DOT)).
                                        </p>
                                    </div>
                                </Col>
                                <Col sm={12} md={6} lg={6} className="electricVehicleTypesTableRight" >
                                    <Row>
                                        <div className="content">
                                            Typically includes all passenger cars, SUVs, pickup trucks, and some small vans (up to 10 seats for passenger transport).
                                        </div>
                                    </Row>
                                    <Row className="borderTop">
                                        <div className="content">
                                            Charged with Level 1, Level 2, and DC fast charging depending on make, models, duty cycle, and fleet needs.
                                        </div>
                                    </Row>
                                    <Row className="borderTop">
                                        <div className="content">
                                            Examples for municipal fleets can include service and inspection sedans, and police cars and motorcycles. <Link to="/ContactUs" target="_self">Connect</Link> with {clientConfig?.CONTENT.EV_ADVISOR_NAME} for a fleet assessment to receive recommendations on available models that suit your needs.
                                        </div>
                                    </Row>
                                </Col>
                            </Row>

                            {/* EV types table - Medium duty EV */}
                            <Row className="my-3 electricVehicleTypesTable surface7Border">
                                <Col sm={12} md={12} lg={2} className="electricVehicleTypesTableLeft surface7Background" >
                                    <div className="content">
                                        Medium-Duty EVs
                                    </div>
                                </Col>
                                <Col sm={12} md={6} lg={4} className="electricVehicleTypesTableCenter" >
                                    <div className="content">
                                        <div className="header">
                                            10,001 to 26,000 pounds
                                        </div>
                                        <p>
                                            Vehicles with a GVWR between 10,001 and 26,000 pounds (i.e., Classes 3 through 6, as designated by the U.S. DOT).
                                        </p>
                                    </div>
                                </Col>
                                <Col sm={12} md={6} lg={6} className="electricVehicleTypesTableRight" >
                                    <Row>
                                        <div className="content">
                                            Typically includes shuttle buses, large passenger vans, large pickup trucks, box trucks, and step vans typically used for delivery and "first mile, last mile" services.
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="content">
                                            Charged by Level 2 or DC fast charging, depending on make, models, duty cycle, and fleet needs.
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="content">
                                            Examples for municipal fleets can include service vans and service trucks. <Link to="/ContactUs" target="_self">Connect</Link> with {clientConfig?.CONTENT.EV_ADVISOR_NAME} for a fleet assessment to receive recommendations on available models that suit your needs.
                                        </div>
                                    </Row>
                                </Col>
                            </Row>

                            {/* EV types table - Heavy duty EV */}
                            <Row className="my-3 electricVehicleTypesTable surface8Border">
                                <Col sm={12} md={12} lg={2} className="electricVehicleTypesTableLeft surface8Background" >
                                    <div className="content">
                                        Heavy-Duty EVs
                                    </div>
                                </Col>
                                <Col sm={12} md={6} lg={4} className="electricVehicleTypesTableCenter" >
                                    <div className="content">
                                        <div className="header">
                                            26,001 pounds and up
                                        </div>
                                        <p>
                                            Vehicles with a GVWR higher than 26,001 pounds (i.e., Class 7 and 8 vehicles, as designated by the U.S. DOT).
                                        </p>
                                    </div>
                                </Col>
                                <Col sm={12} md={6} lg={6} className="electricVehicleTypesTableRight" >
                                    <Row>
                                        <div className="content">
                                            Typically includes buses and large trucks.
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="content">
                                            Charged with Level 2 or DC fast charging, depending on make, models, duty cycle, and fleet needs. For example:
                                            <ul>
                                                <li>Electric school buses can easily charge with high-power Level 2 charging, due to their duty cycle.</li>
                                                <li>Electric transit buses usually charge at a depot overnight or on-route using off-board pantograph or inductive charging.</li>
                                            </ul>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="content">
                                            Examples for municipal fleets can include service vans and service trucks. <Link to="/ContactUs" target="_self">Connect</Link> with {clientConfig?.CONTENT.EV_ADVISOR_NAME} for a fleet assessment to receive recommendations on available models that suit your needs.
                                        </div>
                                    </Row>
                                </Col>
                            </Row>

                            <div className="referenceContent">
                                <p>Learn more at <a href="https://fueleconomy.gov" target="_blank" rel="noreferrer">FuelEconomy.gov</a> and the <a href="https://afdc.energy.gov/" target="_blank" rel="noreferrer">Alternative Fuels Data Center</a>.</p>
                            </div>
                        </Col>
                    </Row>
                </ContentBody>
            </ContentBlock>
        </div>

    );

};
